// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sumObjectsByKey() {
    var objs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objs[_i] = arguments[_i];
    }
    return objs.reduce(function (a, b) {
        for (var k in b) {
            if (b[k]) {
                a[k] = (a[k] || 0) + b[k];
            }
        }
        return a;
    }, {});
}
export var ObjectUtils = { sumObjectsByKey: sumObjectsByKey };
